import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wwmw5suxv7: FaireBrandEntity = {
  token: "b_wwmw5suxv7",
  type: "brand",
  name: "Molly Moon Crafts",
  avatarUrl:
    "https://cdn.faire.com/fastly/d42e9f2227ce720565eb67179b1712d93adaef100c894cf90b1d1165cbce8e79.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/df9a6796ef524d0a95b694a713f890a13bcf16258c2ae9011057e323c4cd837f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d42e9f2227ce720565eb67179b1712d93adaef100c894cf90b1d1165cbce8e79.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/df9a6796ef524d0a95b694a713f890a13bcf16258c2ae9011057e323c4cd837f.jpeg",
  location: "Palm Desert, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    "Molly Moon Crafts uses a mindful and creative process to bring functional art and apothecary from our home to yours. This woman owned business prioritizes creating unique and sustainable products that will elevate your space. Everything is made in small batches with non-toxic ingredients to ensure the highest quality! \n\nEverything is handmade in the desert of the Coachella Valley. \n\nVegan, Non-toxic, Paraben free.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:40.808Z",
    importedBy: "entity-db-cli",
  },
};
